/**
 * Coordinates on-demand session refresh when tokens expire (401).
 * No proactive intervals - refresh only when the token actually returns expired.
 */

let pendingResolve: (() => void) | null = null
let tokenFetchUrl = "/api/auth/supabase-token"

export function setTokenFetchUrl(url: string) {
    tokenFetchUrl = url
}

export function getTokenFetchUrl() {
    return tokenFetchUrl
}

/**
 * Request a session refresh. Returns a promise that resolves when Stytch and Supabase token are refreshed.
 * Dispatches "session-refresh-requested" for SessionRefresh to handle.
 */
export function requestSessionRefresh(): Promise<void> {
    return new Promise(resolve => {
        pendingResolve = resolve
        window.dispatchEvent(new CustomEvent("session-refresh-requested"))
    })
}

/**
 * Call after initSupabaseAuth succeeds to unblock any code waiting on requestSessionRefresh().
 */
export function resolveSessionRefresh() {
    pendingResolve?.()
    pendingResolve = null
}
